<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h1 class="Prelim-head" id="_idParaDest-3"><a id="_idTextAnchor002"></a>Dedication</h1>
<p class="Prelim-text">All my family.</p>
<p class="Prelim-text">Sowe Valley Primary School, Coventry.</p>
<p class="Prelim-text">Richard Lee Primary School, Coventry.</p>
<p class="Prelim-text">Penny Markley.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781528954297_EPUB-3.vue?5bae8ce7